export default __webpack_public_path__ + "static/media/do.68583706.svg";